<template>
  <div>
    <PublicLayout>
      <header
        class="header"
        :style="{
          backgroundImage: `url(${require('@/assets/public/images/company/header.jpg')})`,
        }"
      >
        <div class="container">
          <h1>社長的話</h1>
        </div>
      </header>
      <HeaderNav activeLink="philosophy" />
      <!-- main-section -->
      <section class="main-section">
        <!-- m-sec -->
        <section class="m-sec">
          <div class="container">
            <div class="row">
              <div class="col-md-4"></div>
              <div class="col-md-8">
                <h2 class="section-title text-center">一路有你、一起共好</h2>
              </div>
              <div class="col-md-4">
                <div class="founder-image-box">
                  <img
                    src="@/assets/public/images/founders/社長修3_P01_縮小檔案-1.jpg"
                    alt="社長網頁用照片"
                    class="w-100"
                  />
                  <p class="font-weight-bold mt-3">
                    日商富地滋(股)台灣分公司<br />社長&nbsp;幸田望希
                  </p>
                </div>
              </div>
              <div class="col-md-8" style="position: relative; bottom: 7px">
                <div>
                  <p>
                    日商富地滋從2001年開始，歷經3年的籌備規劃，於2004年正式成立台灣分公司，迄今邁入第20年。<br />
                    「20」是一個深具意義的數字。在日本，是日本人人生中必經的過程，同時也是重要的里程碑之一。<br />
                    它代表著即將迎接的「成年」，代表著我們對自己、對社會的未來擁有更大的責任與義務。<br />
                    在大家的努力下，我們一步步將健康科技帶進每個人的生活，<br />
                    也讓許多人們獲得人生的富足，享有真正的幸福，誠摯感謝各位的支持與信任！
                  </p>
                  <p>
                    2020年，一場突如其來的新型冠狀病毒造成全球性的威脅，<br />
                    改變了我們的生活習慣，也改變了全球化的進程。<br />
                    疫情大大地衝擊世界經濟動能，並且加速了人們對核酸的了解及對健康的重要性。<br />
                    面對如此不確定、充滿挑戰的世界新局，<br />
                    我們需要穩住腳步，依循局勢積極推動符合時局的經營策略，「主動改變、主動出擊！」
                  </p>
                  <p>
                    <!-- 走過艱辛的2020年，期許大家與我們迎接成年的同時，<br /> -->
                    在後疫情時代，我們仍持續投入對社會、環境正向發展的企業責任，<br />
                    並且積極攜手國家研發團隊，促進台灣生技產業的發展，兼顧防疫與生活品質，維護國人的健康。<br />
                    期許大家跟著我們的腳步前進，<br />
                    不斷地給予自己新的計畫、新的夢想，體現生命的價值。<br />
                    最後，讓我們共同凝聚彼此溫暖的心，<br />
                    在這個看似充滿危機、面臨嚴峻挑戰的時代，一起邁向最美好的未來！
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </section>
      <!-- main-section -->
    </PublicLayout>
  </div>
</template>

<script>
import PublicLayout from "../../components/public/PublicLayout";
import HeaderNav from "../../components/public/headerNav/CompanyHeaderNav";
export default {
  name: "CompanyPhilosophyScreen",
  components: {
    PublicLayout,
    HeaderNav,
  },
};
</script>
<style lang="scss" scoped>
.founder-image-box {
  width: 220px;
}
@media (min-width: 768px) {
  .founder-image-box {
    width: 90%;
  }
}
</style>